import { render, staticRenderFns } from "./BlockSectionTags.vue?vue&type=template&id=2c95f6fc&scoped=true&"
import script from "./BlockSectionTags.vue?vue&type=script&lang=ts&"
export * from "./BlockSectionTags.vue?vue&type=script&lang=ts&"
import style0 from "./BlockSectionTags.vue?vue&type=style&index=0&id=2c95f6fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95f6fc",
  null
  
)

export default component.exports